import { axiosClient } from "services/axios";

export function deleteEmployeesGroup(usersgroupid: string | number) {
  return axiosClient.delete("users/user-group", {
    params: { usersgroupid: Number(usersgroupid) },
  });
}
